import { getPayspotMaintenances } from 'admin/actions/devices';
import { formatDate, toQueryParams } from 'admin/utils';
import { ListItem } from 'material-ui/List';
import PropsTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TextBox from '~/javascripts/admin/components/atoms/TextBox';
import FA from '../../../../../atoms/FontAwesome';
import Pager from '../../../../../shared/Pager';
import { parseMaintentanceData } from '../../parsingData';
import { PayspotDetailsCard, PayspotDetailsCardTitle } from '../PayspotDetailsCard';

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ItemKey = styled.span``;
const ItemValue = styled.span``;

const MaintenanceList = styled.div`
  height: 454px;
  overflow-y: auto;
`;

const MaintenanceItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  height: 16px;
  margin: 4px 0px 0px;
  color: rgba(0, 0, 0, 0.54);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  > ${ItemKey} {
    flex: 1;
  }
  > ${ItemValue} {
  }
`;

const PaginationWrapper = styled.div`
  margin: 16px 0;
  ul {
    margin: 0;
  }
`;

const SearchBox = styled.div`
  margin: 8px 8px 0;
  position: relative;

  ${TextBox} {
    ::placeholder {
      color: #d0d0d0;
    }
    border-color: #e8e8e8;
    padding: 8px 48px 8px 8px;
  }
`;

const SearchButton = styled.div`
  padding: 8px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
`;

const SearchIcon = styled(FA)`
  color: #d0d0d0;
`;

const MaintenanceUserAndDate = ({ user, date }) => {
  return (
    <MaintenanceItem>
      <ItemKey>管理者番号: {user ?? '未指定'}</ItemKey>
      <ItemValue>{formatDate(date)}</ItemValue>
    </MaintenanceItem>
  );
};

const MaintenanceLogsCard = ({ payspotId }) => {
  const [maintenances, setMaintenances] = useState({
    rows: [],
    count: 0,
    pagination: {
      current: 1,
      has_next: false,
      has_prev: false,
      max_page: 1,
      per_page: 50,
    },
  });

  const [username, setUsername] = useState('');

  const fetchPayspotMaintenances = (id, pagination = {}) => {
    const params = {
      page: 1,
      per_page: 50,
      ...(username ? { username } : {}),
      ...pagination,
    };
    getPayspotMaintenances(id, toQueryParams(params, true)).then(setMaintenances);
  };

  useEffect(() => {
    fetchPayspotMaintenances(payspotId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payspotId]);

  const onChangePage = (page) => fetchPayspotMaintenances(payspotId, { page });

  const NoData = <span style={{ color: 'gray', fontStyle: 'italic' }}>データなし</span>;

  const { rows, pagination } = maintenances;

  return (
    <PayspotDetailsCard>
      <PayspotDetailsCardTitle>
        端末操作履歴
        <SearchBox>
          <TextBox
            fullWidth
            placeholder="管理者番号を検索"
            syncValue={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(event) => event.key === 'Enter' && fetchPayspotMaintenances(payspotId)}
          />
          <SearchButton onClick={() => fetchPayspotMaintenances(payspotId)}>
            <SearchIcon icon="search" />
          </SearchButton>
        </SearchBox>
      </PayspotDetailsCardTitle>
      <MaintenanceList>
        {rows.length === 0 && <Center>{NoData}</Center>}
        {rows.map((log) => (
          <ListItem
            key={log.id}
            primaryText={parseMaintentanceData(log)}
            secondaryText={<MaintenanceUserAndDate user={log.username} date={log.created_at} />}
            style={{ borderBottom: '1px solid #e5e5e5' }}
          />
        ))}
      </MaintenanceList>
      <PaginationWrapper>
        <Pager pagination={pagination} onChangePage={onChangePage} size="sm" />
      </PaginationWrapper>
    </PayspotDetailsCard>
  );
};

MaintenanceLogsCard.propTypes = {
  payspotId: PropsTypes.string.isRequired,
};

export default MaintenanceLogsCard;
